import { AppEnvironment } from './environment.model'
import { getApiUrls, getIdentityServerConfig } from './environment.utils'
import { EnvType } from '@mediacoach/ui'
import { ENV_COMMON_SETTINGS } from './environment.constants'

// --- Environment-specific Configuration ---
const envType = EnvType.Dv
const bundleId = 'com.sportian.performance.mobile.dv'
const urlScheme = `${bundleId}://`
const clientId = '39f4f70b-c8a2-d3c0-1e1d-d97720429e37'
const appDomain = 'https://mobile-dv.mediacoach.es'
const apiDomain = 'https://mobile-api-dv.mediacoach.es'
const identityServerUrl = 'https://id-dv.mediacoach.es'
const webSocketDomain = 'https://mobile-ws-dv.mediacoach.es'
const staticsUrlCloud = 'https://festatics-dv.performance.sportian.dev'
const portalDownloadUrl = 'https://portal-dv.mediacoach.es/descargas'
const smartlookApiKey = '3df4d8f4170d79ddb97fe2ab39911626944edc75'

export const environment: AppEnvironment = {
  ...ENV_COMMON_SETTINGS,
  bundleId,
  envType,
  smartlookApiKey,
  appDomain,
  apiDomain,
  identityServerUrl,
  staticsUrlCloud,
  portalDownloadUrl,
  urlScheme,
  production: false,
  enableContextMenu: true,
  identityServerConfig: (isNative = false, domain = window.location.origin) =>
    getIdentityServerConfig(identityServerUrl, urlScheme, clientId, isNative, domain),
  api: getApiUrls(apiDomain, identityServerUrl, clientId, webSocketDomain)
}
